 
import $ from 'jquery';
import ko from 'knockout';
import Quiz from './viewmodels/quiz';

export default function riskAssessorQuiz(data){
    ko.applyBindings(new Quiz(data, $(window)), $('#category')[0]);
}
